import { useState, useEffect } from "react";

const rotating = ["sala", "junta", "presentación", "reunión", "negociación"];

export default function Book() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % rotating.length), 2400);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      id="somaseia"
      data-testid="book-section"
      className="relative py-20 lg:py-28 bg-[#030303] border-t border-[#B49A6C]/10 overflow-hidden"
    >
      <div className="absolute inset-0 pattern-hypnotic-radial" />
      <div className="absolute -right-40 -top-40 w-[900px] h-[900px] pattern-rings opacity-25 spin-slow rounded-full" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <p className="text-[10px] uppercase tracking-[0.45em] text-[#B49A6C] mb-12 flex items-center gap-4">
          <span className="h-px w-12 bg-[#B49A6C]/50" />
          Edición de autor · Somaseia
        </p>

        <div className="grid lg:grid-cols-12 gap-16 lg:gap-20 items-center">
          {/* Book image */}
          <div className="lg:col-span-5 relative">
            <div
              className="absolute inset-0 -z-10 blur-3xl opacity-50"
              style={{
                background:
                  "radial-gradient(circle at center, rgba(217,205,168,0.25) 0%, transparent 65%)",
              }}
            />
            <img
              src="/book-somaseia.png"
              alt="Libro Somaseia"
              data-testid="book-image"
              className="relative w-full max-w-md mx-auto lg:mx-0 drop-shadow-[0_30px_60px_rgba(0,0,0,0.7)]"
            />
          </div>

          {/* Text */}
          <div className="lg:col-span-7">
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#E8E5DC] mb-3">
              <span className="italic text-metal">Somaseia.</span>
            </h2>
            <p className="text-[10px] uppercase tracking-[0.4em] text-[#807C70] mb-10">
              Lenguaje corporal · Señales subconscientes
            </p>

            <p className="text-base sm:text-lg text-[#A89F8E] leading-loose font-light tracking-wide">
              En mi primer libro, <span className="text-[#E8E5DC]">Somaseia</span>,
              explorarás todo lo relacionado al lenguaje corporal y las señales
              subconscientes. Aprenderás cómo dominarlas y manipularlas a tu
              favor, convirtiéndote en la persona más{" "}
              <span className="text-[#E8E5DC]">peligrosa</span> en cualquier{" "}
              <span
                data-testid="book-rotating"
                key={idx}
                className="inline-block italic text-metal animate-[fadeUp_0.8s_ease-out]"
              >
                {rotating[idx]}
              </span>
              , estando siempre un paso antes — viendo lo que nadie más ve.
            </p>

            <div className="divider-metal my-10" />

            <p className="text-base sm:text-lg text-[#A89F8E] leading-loose font-light tracking-wide">
              Este libro es un{" "}
              <span className="text-[#E8E5DC]">compendio ejecutivo</span> de
              todo lo que vemos extensa y detalladamente en los programas.
            </p>

            <div className="mt-12 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-7">
              <a
                href="https://www.skool.com/subconscious-lab-4167/about"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="book-cta"
                className="group/btn relative inline-flex items-center justify-center text-[10px] uppercase tracking-[0.4em] px-10 py-5 overflow-hidden border border-[#B49A6C]/30 hover:border-[#C9C2B0]/70 transition-all duration-700"
                style={{
                  background:
                    "linear-gradient(180deg, #1F1B14 0%, #0C0A07 55%, #000000 100%)",
                  boxShadow:
                    "inset 0 1px 0 rgba(217,205,168,0.10), inset 0 -1px 0 rgba(0,0,0,0.6), 0 0 28px rgba(0,0,0,0.5)",
                }}
              >
                <span
                  aria-hidden
                  className="absolute inset-0 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-700"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(217,205,168,0.10) 0%, rgba(180,154,108,0.04) 50%, transparent 100%)",
                  }}
                />
                <span
                  className="relative"
                  style={{
                    background:
                      "linear-gradient(180deg, #F0E6CC 0%, #C9B584 45%, #6E5B36 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                  }}
                >
                  Adquiere el libro
                </span>
              </a>
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#807C70] max-w-[18rem] leading-relaxed">
                El libro es gratuito en las membresías anuales.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(8px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
